import React, { Component } from 'react';
import './Svg.scss';
import './Icon.scss';

export default class TriangleIcon extends Component {
    render () {
        const { className, colorIndex, size } = this.props;
        let colorClass = 'color--' + colorIndex;
        let sizeClass = 'size--' + size;
        let finalClassName = "Icon " + className + " " + sizeClass + " " + colorClass;

        return (
            <svg className={finalClassName} width="8px" height="8px" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 6V2.41421C7 1.52331 5.92286 1.07714 5.29289 1.70711L1.70711 5.29289C1.07714 5.92286 1.52331 7 2.41421 7H6C6.55228 7 7 6.55228 7 6Z" fill="#FF8340" stroke="#FF8340" />
            </svg>
           );
    }
}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Icon/Triangle.js